export const queryKeys = {
  // Model
  analogueModel: (id: string) => ['analogue-model', id] as const,
  analogueModels: () => ['analogue-models'] as const,

  // Compute
  modelCases: (modelId: string) => ['model-cases', modelId] as const,
  computeSettings: (modelId: string) => ['compute-settings', modelId] as const,
  computeCaseLog: (modelId: string, computeCaseId: string) =>
    ['compute-case-log', modelId, computeCaseId] as const,

  // Reference / SMDA data
  outcrops: () => ['outcrop'] as const,
  outcropsList: () => ['apiParameters'] as const,
  modelAreaTypes: () => ['model-area'] as const,
  smdaCountries: () => ['smda-countries'] as const,
  smdaFields: () => ['smda-fields'] as const,
  smdaStratColumns: () => ['smda-strat-columns'] as const,
  smdaStratUnits: () => ['smda-strat-units'] as const,
  smdaGDE: () => ['smda-GDE'] as const,

  // Results
  variogramResults: (modelId: string) =>
    ['variogram-results', modelId] as const,
  objectResults: (modelId: string) => ['object-results', modelId] as const,
  caseImage: (imageId: string) => ['case-image', imageId] as const,
  archelProportions: (modelId: string, scope: unknown) =>
    ['archel-proportions', modelId, scope] as const,

  // Scenarios
  scenarioTemplates: () => ['scenario-templates'] as const,
  scenarios: () => ['scenarios'] as const,
  modelScenarios: (modelId: string) => ['scenarios', 'model', modelId] as const,
  scenario: (scenarioId: string) => ['scenario', scenarioId] as const,

  // Orchestration / Simulation
  orchestration: (orchestrationId: string) =>
    ['orchestration', orchestrationId] as const,
  orchestrationProgress: (orchestrationId: string) =>
    ['orchestration-progress', orchestrationId] as const,
  orchestrationResults: (orchestrationId: string) =>
    ['orchestration-results', orchestrationId] as const,
  categorizedImages: (orchestrationId: string) =>
    ['categorized-images', orchestrationId] as const,

  // Jobs
  jobs: (id: string) => ['jobs', id] as const,

  // Images
  orchestrationImage: (orchestrationId: string, filename: string) =>
    ['orchestration-image', orchestrationId, filename] as const,
  archelGrid: (modelId: string) => ['archel-grid', modelId] as const,
} as const;
